// extracted by mini-css-extract-plugin
export default {"button":"styles_button__EUUX-","input":"styles_input__jVtxf"};